import Carousel, {
  ArrowProps,
  CarouselProps,
  ResponsiveType,
} from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { ReactNode } from 'react'
import { ChevronLeft, ChevronRight } from 'react-feather'
import { responsive as defaultResponsive } from '@common/constants'

type CommonCarouselProps = {
  children: ReactNode
  className?: string
  responsive?: ResponsiveType
  hasArrows?: boolean
}

const CustomNavButton = ({
  onClick,
  direction,
}: ArrowProps & { direction: string }) => {
  return (
    <button
      aria-label={`Go to ${direction} slide`}
      className={`react-multiple-carousel__arrow z-0 flex items-center justify-center ${
        direction === 'previous' ? 'left-0' : 'right-0'
      }`}
      type="button"
      onClick={onClick}
      style={{ zIndex: 0 }}
    >
      {direction === 'previous' ? (
        <ChevronLeft size={32} color="white" />
      ) : (
        <ChevronRight size={32} color="white" />
      )}
    </button>
  )
}

const CommonCarousel = ({
  children,
  className = '',
  responsive = defaultResponsive,
  hasArrows,
  ...props
}: Partial<CarouselProps> & CommonCarouselProps) => {
  return (
    <>
      <Carousel
        responsive={responsive}
        autoPlay={true}
        autoPlaySpeed={5000}
        swipeable={true}
        draggable={true}
        showDots={true}
        infinite={true}
        partialVisible={false}
        itemClass="flex justify-center items-center"
        pauseOnHover={true}
        dotListClass="flex justify-center items-center p-0 mt-10 carousel-dots gap-1 md:gap-2 py-1 my-0 mx-auto max-w-screen-sm"
        sliderClass="px-5"
        arrows={hasArrows ?? false}
        containerClass={`custom-corousel-container pb-10 overflow-hidden ${className}`}
        customLeftArrow={
          hasArrows ? <CustomNavButton direction="previous" /> : null
        }
        customRightArrow={
          hasArrows ? <CustomNavButton direction="next" /> : null
        }
        {...props}
      >
        {children}
      </Carousel>

      <style jsx global>{`
        .react-multi-carousel-dot-list {
          margin: auto;
        }
        .carousel-dots li.react-multi-carousel-dot {
          flex: 1;
          max-width: 25px;
          transition: all 0.3s ease;
        }

        .carousel-dots li.react-multi-carousel-dot--active {
          flex: 1.5;
          max-width: 40px;
        }

        .carousel-dots li.react-multi-carousel-dot button {
          height: 6px;
          width: 100%;
          border-radius: 7px;
          background-color: #d1d5db;
          border: none;
          cursor: pointer;
          transition: none;
        }

        .carousel-dots li.react-multi-carousel-dot--active button {
          background-color: #ff5a43;
          height: 8px;
          width: 100%;
          box-shadow: 0px 3px 4px 1px #ff5a43aa;
        }
      `}</style>
    </>
  )
}

export default CommonCarousel
